/* FAVORITES PAGE */

document.addEventListener("DOMContentLoaded", () => {
    const favs = document.querySelectorAll('#favor .catalog-card__fav')
    const fav =  document.getElementById('favor')
    const noFav = document.getElementById('noFavorites')
    const noFavs = document.querySelectorAll('.catalog--favorites-nohave .iWishAddColl.iwishcheck.iwishCollection')
    let iwishCount = window.localStorage.getItem('iWishCnt')
    const favHiddenClass = 'favorites-hidden'
    toggleWishlist(iwishCount, fav, noFav, favHiddenClass)
    favs.forEach((e) => {
        e.addEventListener('click', () => {
            iwishCount = (window.localStorage.getItem('iWishCnt') - 1)
            toggleWishlist(iwishCount, fav, noFav, favHiddenClass)
        })
    });
    noFavs.forEach((e) => {
        e.addEventListener('click', () => {
            location.reload()
        })
    })
})
/* SHOW FAVORITE / NO FAVORITES */

function toggleWishlist(iwishCount, fav, noFav, favHiddenClass) {
    if (iwishCount > 0){
        fav.classList.remove(favHiddenClass);
        noFav.classList.add(favHiddenClass);
    } else {
        noFav.classList.remove(favHiddenClass);
        fav.classList.add(favHiddenClass);
    }
}



/* SHARE WISHLIST */
$('#shareWish').on('click',function (){
    shareWishList()
})
function shareWishList() {
    // Create a "hidden" input
    var aux = document.createElement("input");
    var message = document.createElement("p");
    $(message).show()
    // Assign it the value of the specified element
    aux.setAttribute("value", document.getElementById('shareUrl').innerHTML);
    message.innerText = 'copied to clipboard';
    message.classList.add('clipboard')

    // Append it to the body
    document.body.appendChild(aux);

    // Highlight its content
    aux.select();

    // Copy the highlighted text
    document.execCommand("copy");
    $('#shareWish').off('click')
    // Remove it from the body
    document.body.removeChild(aux);
    $('.favorites__head').append(message)
    setTimeout(function (){
        $(message).hide()
        $('#shareWish').on('click',function (){
            shareWishList()
        })
    },2000)
}